import { ConnectionPositionPair } from '@angular/cdk/overlay';

const genPositionPairs = ({ positionX, positionY, offsetX = 0, offsetY = 0 }, isResponsive) => {
    const positions = [
        new ConnectionPositionPair({ originX: positionX, originY: positionY }, {
            overlayX: positionX,
            overlayY: positionY
        }, offsetX, offsetY),
        new ConnectionPositionPair({ originX: "center", originY: "bottom" }, { overlayX: "center", overlayY: "top" }, offsetX, offsetY),
        new ConnectionPositionPair({ originX: "center", originY: "top" }, { overlayX: "center", overlayY: "bottom" }, offsetX, offsetY),
        new ConnectionPositionPair({ originX: "start", originY: "bottom" }, { overlayX: "start", overlayY: "top" }, offsetX, offsetY),
        new ConnectionPositionPair({ originX: "start", originY: "top" }, { overlayX: "start", overlayY: "bottom" }, offsetX, offsetY),
        new ConnectionPositionPair({ originX: "end", originY: "bottom" }, { overlayX: "end", overlayY: "top" }, offsetX, offsetY),
        new ConnectionPositionPair({ originX: "end", originY: "top" }, { overlayX: "end", overlayY: "bottom" }, offsetX, offsetY)
    ];
    return isResponsive ? positions : positions.slice(0, 1);
};

/**
 * Generated bundle index. Do not edit.
 */

export { genPositionPairs };

